import { TOauth2Props, useOAuth2 } from '@tasoskakour/react-use-oauth2';
import { AuthResponse } from '../../state';

export const useOAuth2Localized = (data: TOauth2Props<AuthResponse>) => {
  const { getAuth: getAuthEn } = useOAuth2<AuthResponse>({
    ...data,
    extraQueryParameters: {
      kc_locale: 'en',
      ui_locales: 'en',
    },
  });

  const { getAuth: getAuthIta } = useOAuth2<AuthResponse>({
    ...data,
    extraQueryParameters: {
      kc_locale: 'it',
      ui_locales: 'it',
    },
  });

  const { getAuth: getAuthFr } = useOAuth2<AuthResponse>({
    ...data,
    extraQueryParameters: {
      kc_locale: 'fr',
      ui_locales: 'fr',
    },
  });

  const { getAuth: getAuthEs } = useOAuth2<AuthResponse>({
    ...data,
    extraQueryParameters: {
      kc_locale: 'es',
      ui_locales: 'es',
    },
  });

  return {
    getAuthEn,
    getAuthIta,
    getAuthFr,
    getAuthEs,
  };
};
